import { TRIGGER_TOAST_ON, TRIGGER_TOAST_OFF } from './constants';

export function triggerToastOn({
    toastMessage,
    toastType,
    toastAutoHideDuration,
    toastAnchorOrigin,
}) {
    return {
        type: TRIGGER_TOAST_ON,
        toastMessage,
        toastAutoHideDuration,
        toastType,
        toastAnchorOrigin,
    };
}

export function triggerToastOff() {
    return {
        type: TRIGGER_TOAST_OFF,
    };
}
